import { AdminBreadcrumb } from "@/components/admin/AdminBreadcrumb";
import { type Column, DataTable } from "@/components/admin/DataTable";
import { useAdminStudents } from "@/hooks/useAdminData";
import type { StudentSummary } from "@/lib/api-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export function AdminStudentList() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { data, isLoading } = useAdminStudents();

	const students = data?.students ?? [];

	const columns: Column<StudentSummary & Record<string, unknown>>[] = [
		{
			key: "name",
			header: t("admin.name"),
			sortable: true,
			render: (item) => <span className="font-medium text-primary">{item.name}</span>,
		},
		{
			key: "email",
			header: t("admin.email"),
			sortable: true,
			render: (item) => <span className="text-secondary">{item.email}</span>,
		},
		{
			key: "enrolled_courses",
			header: t("admin.enrolledCourses"),
			sortable: true,
		},
		{
			key: "last_active",
			header: t("admin.lastActive"),
			sortable: true,
			render: (item) => (
				<span className="text-secondary">
					{item.last_active ? new Date(item.last_active as string).toLocaleDateString() : "-"}
				</span>
			),
		},
	];

	return (
		<div className="space-y-6">
			<AdminBreadcrumb
				items={[{ label: t("admin.dashboard"), href: "/admin" }, { label: t("admin.students") }]}
			/>

			<h1 className="text-3xl font-bold text-primary">{t("admin.students")}</h1>

			<DataTable
				columns={columns}
				data={students as (StudentSummary & Record<string, unknown>)[]}
				isLoading={isLoading}
				emptyMessage={t("admin.noStudents")}
				searchPlaceholder={t("admin.searchStudents")}
				searchFilter={(item, query) => {
					const q = query.toLowerCase();
					return (
						(item.name as string).toLowerCase().includes(q) ||
						(item.email as string).toLowerCase().includes(q)
					);
				}}
				onRowClick={(item) => navigate(`/admin/students/${item.id}`)}
			/>
		</div>
	);
}
